<template>
  <app-modal
    v-model="isDialogOpened"
    size="xs"
    :ok-text="$t('common.confirm')"
    @cancel="closeDialog"
    @ok="onConfirm"
  >
    <template #title>{{ $t('project.signing-checklist.envelope-templates.dialogs.DeleteFileDialog.title') }}</template>

    <template #body>
      <p>{{ $t('project.signing-checklist.envelope-templates.dialogs.DeleteFileDialog.warning') }}</p>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'DeleteFileDialog',
  mixins: [dialogMixin],
  methods: {
    onConfirm () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
})
</script>
